<template>
  <div class="infoEvent">
    <img id="logo"
      src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FDETALLE%20DEL%20EVENTO%20ICONO.svg?alt=media&token=4f775a55-a420-4976-b199-9f291b92fd70"
      alt="" />
    <div class="title">
      <h2>DETALLES DEL EVENTO</h2>
    </div>
    <div class="branch">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FDETALLE%20DEL%20EVENTO.svg?alt=media&token=fb54c11f-cc68-4cd8-8b10-50860461abd4"
        alt="" />
    </div>
    <br>
    <!--  -->
    <div class="event">
      <div id="ceremonia">
        <h2>CEREMONIA</h2>
      </div>
      <img :src="InfoEvent.FotoEvento" class="foto" alt="" />
      <p id="day" style="font-size: 1.5rem;">{{ moment(InfoEvent.FechaHoraEvento, "dddd DD") }} de {{ moment(InfoEvent.FechaHoraEvento, "MMMM") }}</p>
      <br>
      <h2 class="hour">{{ moment(InfoEvent.FechaHoraEvento, "h:mm ") }} p.m.</h2>
      <br>
      <p style="font-weight: 700; text-align: center; font-size: 1.7rem; width: 70%;">{{ InfoEvent.LugarEvento }}</p>
      <br>
      <p style="text-align: center;  font-weight: 100; font-size: 1.5rem; width: 70%;">
        Col. El Tesoro. Diócesis
      </p>
      <p style="text-align: center;  font-weight: 100; font-size: 1.5rem; width: 70%;">
        San Miguel, San Miguel
      </p>
      <br>
      <div class="buttons">
        <button style="height: 3rem" @click="goToLink('https://maps.app.goo.gl/CFYKwhPqx1K1h6Cs5')">
          <font-awesome-icon :icon="['fas', 'map-location-dot']" /> Cómo Llegar
        </button>
        <button style="height: 3rem"
          @click="goToLink('https://ul.waze.com/ul?preview_venue_id=178126983.1781466434.4146127&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location')">
          <font-awesome-icon :icon="['fab', 'waze']" /> Cómo Llegar
        </button>
        <add-to-calendar-button proKey="8789c744-c3ab-4447-81ea-370f269c387f" />
      </div>
    </div>
    <br>
    <div class="reception">
      <div>
        <h2>RECEPCIÓN</h2>
      </div>
      <img :src="InfoEvent.FotoRecepcion" class="foto" alt="" />
      <p class="hour">{{ moment(InfoEvent.FechaHoraRecepcion, "h:mm") }} p.m.</p>
      <br>
      <p style="font-weight: 700; font-size: 1.7rem;">{{ InfoEvent.LugarRecepcion }}</p>
      <br>
      <p style="text-align: center; margin-left: 3rem; margin-right: 3rem; font-weight: 100; font-size: 1.5rem;">
        Avenida Rooseverlt,
      </p>
      <p style="text-align: center; margin-left: 3rem; margin-right: 3rem; font-weight: 100; font-size: 1.5rem;">
       Plaza Chaparrastique,
      </p>
      <p style="text-align: center; margin-left: 3rem; margin-right: 3rem; font-weight: 100; font-size: 1.5rem;">
        Local #2, San Miguel
      </p>
      <br>
      <div class="buttons2">
        <button style="height: 3rem" @click="goToLink('https://maps.app.goo.gl/3SqwrTjAwPLZ3566A')">
          <font-awesome-icon :icon="['fas', 'map-location-dot']" /> Cómo Llegar
        </button>
        <button style="height: 3rem" @click="goToLink('https://ul.waze.com/ul?preview_venue_id=178126983.1781335364.2377976&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location')">
          <font-awesome-icon :icon="['fab', 'waze']" /> Cómo Llegar
        </button>
      </div>
    </div>
    <br>
    <br>
    <div class="dresscode">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FDRESS%20CODE.svg?alt=media&token=bb9a7ee0-6f38-4c68-9323-73e5ea4a9dd5"
        style="width: 10rem" alt="" />
        <h2 class="text-center gris" style="font-family: var(--titulos); color: var(--title); font-size: 2rem;">DRESS CODE</h2>
        <br>
        <h3>Vestimenta Formal</h3>
        <br>
        <p class="text-center" style="width: 50%;">Evita los colores blanco, ivory,</p>
        <p class="text-center" style="width: 50%;"> crema o derivados en tu outfit</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "add-to-calendar-button";

export default {
  name: "InfoEvento",
  props: {
    Code: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      InfoEvent: {
        FechaHoraEvento: "2024-01-20T16:00:00.000Z",
        FechaHoraRecepcion: "2024-01-20T16:00:00.000",
      },
      diferencial: this.$route.query.id,
      key: "",
    };
  },
  methods: {
    GetInfoEvent() {
      let url = process.env.VUE_APP_API_DEV
        ? `${process.env.VUE_APP_API_DEV}Event/GetInfoEvent/${this.Code}`
        : `${process.env.VUE_APP_API_PRO}Event/GetInfoEvent/${this.Code}`;
      axios
        .get(url)
        .then((response) => (this.InfoEvent = response.data))
        .catch((err) => console.error(err));
    },

    moment: function (date, format) {
      var _date = new Date(date.replaceAll("T", " ").replaceAll(".000Z", ""));
      return moment(_date).locale("es-mx").format(`${format}`);
    },

    goToLink(link) {
      window.open(link, "_blank");
    },
  },
  created() {
    this.GetInfoEvent();
  },
};
</script>

<style scoped>
.infoEvent {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-row-gap: 10px;
  width: 75%;
  justify-items: center;
  color: var(--text);
}

.flower {
  grid-area: 1 / 1 / 2 / 2;
}

.title {
  grid-area: 2 / 1 / 3 / 2;
}

.branch {
  grid-area: 3 / 1 / 4 / 2;
}

.branch>img {
  width: 100%;
}

.subtitle {
  grid-area: 4 / 1 / 5 / 2;
}

#day {
  color: var(--text);
  text-transform: capitalize;
}

button {
  background: var(--btn);
  color: var(--btn-text);
  border-radius: 6px;
  box-shadow: var(--btn-shadow);
  height: 2.7rem;
  margin-top: 0.2rem;
  font-weight: 600;
  font-size: 16px;
}

button:hover {
  box-shadow: var(--btn-shadow-hover);
}

button:active {
  box-shadow: var(--btn-shadow-active);
}

.event {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  align-items: baseline;
  justify-items: center;
  width: 95%;
  grid-column: 1 / 2;
}

.foto {
  height: 24rem;
  width: 18rem
}

.reception {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  place-items: center;
  width: 100%;
  grid-column: 1 / 2;
}

.dresscode {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  place-items: center;
  width: 100%;
  grid-column: 1 / 2;
}

.buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  height: 100%;
  padding-bottom: 1rem;
}

#rules {
  width: 30rem;
}

.day {
  font-weight: 200;
}

.buttons2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  height: 100%;
  padding-bottom: 1rem;
}

h2 {
  font-family: var(--titulos);
  color: var(--title);
  font-size: 2rem;
  font-weight: 300;
}

.hour {
  color: var(--title);
  font-size: 1.5rem;
  font-weight: 300;
}

#logo {
  width: 5rem;
  grid-column: 1 / 4;
}


@media (max-width: 768px) {
  .infoEvent {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .branch>img {
    width: 100%;
  }


  .event {
    grid-row-gap: 10px;
    padding-bottom: 1rem;
  }

  .reception {
    grid-row-gap: 10px;
  }

  .buttons {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    height: 100%;
  }

  .buttons2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    height: 100%;
  }

  button {
    display: block;
    margin: 0 auto;
    width: 11.5rem;
    height: 2rem;
  }

  #ceremonia {
    height: 2rem !important;
  }

  #logo {
    grid-column: 1 / 2;
  }

  #rules {
    width: 100%;
  }
}</style>
